module.exports = __webpack_public_path__ + "img/news_edit.34b10698.svg";